import classNames from 'classnames';
import type { TextAvatarProps } from './types';
import './textAvatar.scss';

const CONFLICT_USER_COLORS = [
  '#F5A36C',
  '#6ACCA3',
  '#F5D57F',
  '#F57F83',
  '#7FB1F5',
  '#A393F5',
  '#52CCC2',
];

/**
 * Circular initials avatar for a user who has no photo. Labels the circle with the first characters of the first and last name and picks the background from CONFLICT_USER_COLORS indexed by the doubled character code of the first name, defaulting to white.
 *
 * @param props - The user data holding first and last name, plus an optional class name.
 * @returns The rendered avatar element.
 */
const TextAvatar = (props: TextAvatarProps) => {
  const { data, className = undefined } = props;
  const { firstName, lastName } = data || {};

  const firstCharacterOfFirstName = firstName?.charAt(0) || '';
  const firstCharacterOfLastName = lastName?.charAt(0) || '';
  const charactersInHex = (firstName?.charCodeAt(0) || 0) + (firstName?.charCodeAt(0) || 0);
  const backgroundColor =
    CONFLICT_USER_COLORS[charactersInHex % CONFLICT_USER_COLORS.length] || 'white';

  return (
    <div className={classNames('avatar-wrapper', className)} style={{ backgroundColor }}>
      <span className="name">{`${firstCharacterOfFirstName}${firstCharacterOfLastName}`}</span>
    </div>
  );
};

export default TextAvatar;
